var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c("topbar", { attrs: { text: "查看报告" } }),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "top" }, [
            _c("div", { staticClass: "scoreBox" }, [
              _c("div", { staticClass: "score" }, [
                _c("span", [_vm._v(_vm._s(_vm.score))]),
                _vm._v("分")
              ]),
              _vm._v("\n                    本次测评总得分\n                ")
            ])
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", { attrs: { id: "myChart" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "lastTitle" }, [_vm._v("测试结果：")]),
          _vm._v(" "),
          _c("div", { staticClass: "lastContent" }, [
            _vm._v(_vm._s(_vm.testResult))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                _vm.to("mentalExperience?comboId=" + _vm.comboId)
              }
            }
          },
          [_vm._v("返回心理体检")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "assessTitle" }, [
      _c("div", { staticClass: "assessLeft" }),
      _vm._v(" "),
      _c("span", [_vm._v("总体性评估")]),
      _vm._v(" "),
      _c("div", { staticClass: "assessRight" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2db0bdc7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2db0bdc7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/correctResult.vue
// module id = null
// module chunks = 